import { useQueryRules } from "react-instantsearch-hooks-web";
import SearchPromoBobbyBerk from "./SearchPromoBobbyBerk";
import SearchPromoCampaign from "./SearchPromoCampaign";
import SearchPromoCommunity from "./SearchPromoCommunity";

export default function PromoSwitcher() {
  const { items } = useQueryRules( );
  
  if ( items.some( ( item ) => item.promo_type === 'search_promo_campaign' ) ) {
    return <SearchPromoCampaign />;
  }

  if ( items.some( ( item ) => item.promo_type === 'community' ) ) {
    return <SearchPromoCommunity />;
  }

  if ( items.some( ( item ) => item.promo_type === 'designer_collections' ) ) {
    return <SearchPromoBobbyBerk />;
  }

  return null;
}